<template>
    <div class="">

        <!-- Países configurados -->
        <History/>

    </div>
</template>

<script>

// Importaciones generales
import { mapActions, mapState } from 'vuex';

// Componentes
import History from './fragments/History.vue'

export default {
    name: 'indexConfigurableVariables',
    props: [],
    components: {
        History
    },
    computed: {
        // Estados del modulo Empresas
        ...mapState('empresa', [
            'selectedEmpresa'
        ]),
        // Estados del modulo Configuración de países
        ...mapState('configurableVariables', [
            'filter'
        ])
    },
    async mounted() {
        /**
         * Cargar Configuración de países.
         * 
         * @author Fernando CLaros Garcia
         */
        const payload = {
            companyId: this.selectedEmpresa.id,
            page: this.filter.page,
            status: 'ALL'
        };
        this.loadConfigurableVariables(payload);
        /**
         * Cargar Listas.
         * 
         * @param idControl: (0: Carga toas las listas, id: cargar las listas de un control especifico).
         * @author Fernando CLaros Garcia
         */
        this.loadLists(10);
        /**
         * Cargar Países.
         * 
         * @author Fernando CLaros Garcia
         */
        this.loadConfiguredCountries();
    },
    methods: {
        // Metodos del modulo Listas
        ...mapActions('sysList', [
            'loadLists'
        ]),
        // Metodos del modulo Países
        ...mapActions('countries', [
            'loadConfiguredCountries'
        ]),
        // Mutaciones del modulo Configuración de países
        ...mapActions('configurableVariables', [
            'loadConfigurableVariables'
        ])
    }
}
</script>

<style scoped>
</style>